import _defineProperty from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useRef } from 'react';
var useBattlesJoinTime = function useBattlesJoinTime(_ref) {
  var battlesStarted = _ref.battlesStarted,
    isPlayerJoining = _ref.isPlayerJoining,
    rawStandings = _ref.rawStandings,
    setTableData = _ref.setTableData;
  var timeoutsRef = useRef([]);
  useEffect(function () {
    timeoutsRef.current.forEach(clearTimeout);
    timeoutsRef.current = [];
    if (!(battlesStarted && isPlayerJoining && rawStandings.length)) return;
    setTableData(rawStandings.map(function (p) {
      return _objectSpread(_objectSpread({}, p), {}, {
        hasJoined: false
      });
    }));
    rawStandings.forEach(function (player) {
      var delayMs = player.joinTime * 1000;
      var tid = setTimeout(function () {
        setTableData(function (prev) {
          return prev.map(function (p) {
            return p.name === player.name ? _objectSpread(_objectSpread({}, p), {}, {
              hasJoined: true
            }) : p;
          });
        });
      }, delayMs);
      timeoutsRef.current.push(tid);
    });
    return function () {
      timeoutsRef.current.forEach(clearTimeout);
      timeoutsRef.current = [];
    };
  }, [battlesStarted, isPlayerJoining, rawStandings, setTableData]);
};
export default useBattlesJoinTime;